// SVG grafiği PNG olarak indirir (HA grafiklerinin "sunuma koy" ihtiyacı — spec:
// docs/superpowers/specs/2026-08-03-ha-devir-kohort-birlesik-sayfa-design.md).
//
// Bilinen kısıt: <img> içine yüklenen serbest bir SVG sayfa fontlarına ERİŞEMEZ — metinler
// Nunito yerine sistem sans-serif'iyle rasterize edilir. Kabul edilmiş bir sınırlama.
//
// `legend`: [{ label, color }] — SVG'nin DIŞINDA (HTML'de) yaşayan lejantlar (FunnelPlot)
// PNG'de kaybolmasın diye canvas'ın altına programatik işlenir.
export function downloadSvgAsPng(
  svgEl,
  { fileName, background = '#ffffff', scale = 2, legend = [], legendTextColor = '#333333' } = {}
) {
  if (!svgEl) return Promise.resolve(false);

  const vb = svgEl.viewBox && svgEl.viewBox.baseVal;
  const width = (vb && vb.width) || svgEl.clientWidth || 640;
  const height = (vb && vb.height) || svgEl.clientHeight || 320;

  // React svg'yi width="100%" ile render eder; <img>'e yüklenen serbest SVG'de %100'ün
  // referansı olmadığından tarayıcı 300×150 varsayılanına düşer — klona piksel boyut yazılır.
  const clone = svgEl.cloneNode(true);
  clone.setAttribute('width', width);
  clone.setAttribute('height', height);

  const xml = new XMLSerializer().serializeToString(clone);
  const svgUrl = URL.createObjectURL(new Blob([xml], { type: 'image/svg+xml;charset=utf-8' }));

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(svgUrl);

      const legendHeight = legend.length > 0 ? 30 : 0;
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(width * scale);
      canvas.height = Math.round((height + legendHeight) * scale);
      const ctx = canvas.getContext('2d');
      ctx.scale(scale, scale);
      ctx.fillStyle = background;
      ctx.fillRect(0, 0, width, height + legendHeight);
      ctx.drawImage(img, 0, 0, width, height);

      if (legend.length > 0) {
        const ly = height + legendHeight / 2;
        let lx = 16;
        ctx.font = '11px sans-serif';
        ctx.textBaseline = 'middle';
        legend.forEach(({ label, color }) => {
          ctx.fillStyle = color;
          ctx.beginPath();
          ctx.arc(lx + 5, ly, 5, 0, Math.PI * 2);
          ctx.fill();
          ctx.fillStyle = legendTextColor;
          ctx.fillText(label, lx + 16, ly);
          lx += 16 + ctx.measureText(label).width + 20;
        });
      }

      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('png-encode-failed'));
          return;
        }
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(a.href);
        resolve(true);
      }, 'image/png');
    };
    img.onerror = () => {
      URL.revokeObjectURL(svgUrl);
      reject(new Error('svg-render-failed'));
    };
    img.src = svgUrl;
  });
}
